import useIsMobile from "../../../utils/useIsMobile";
import { useDeliveryFlowStore } from "../../../store/newVehicleDeliveryStore";

export const DeliveryookingStepper = () => {
  const isMobile = useIsMobile(768)

  const uiStep = useDeliveryFlowStore((s) => s.uiStep);
   

  const stepTitles = [
    {
      stepNumber : "1",
      title : "Τρόπος εξυπηρέτησης",
    },
    {
      stepNumber : "2",
      title : "Προγραμματισμός ραντεβού",
    },
    {
      stepNumber : "3",
      title : "Ολοκλήρωση",
    }]

  const gradientStepStops = {
    1 : [
          "#FFD0DB 13%",
          "#F5F5F7 23%",
        ],
    2 : [
          "#FFD0DB 35%",
          "#F5F5F7 50%",
        ],
    3 : [
          "#FFD0DB 70%",
          "#F5F5F7 80%",
        ],
    4 : [
          "#FFD0DB 80%",
          "#FFD0DB 100%",
        ],  
    }

  const gradientStepStopsMobile = {
    1 : [
          "#FFD0DB 15%",
          "#FFFFFF 30%",
        ],
    2 : [
          "#FFD0DB 40%",
          "#FFFFFF 55%",
        ],
    3 : [
          "#FFD0DB 65%",
          "#FFFFFF 80%",
        ],
    4 : [
          "#FFD0DB 80%",
          "#FFD0DB 100%",
        ],  
    }

  const gradient = `linear-gradient(${isMobile ? "to bottom" : "to right"}, ${isMobile ? gradientStepStopsMobile[uiStep].join(", ") : gradientStepStops[uiStep].join(", ")})`;

  return (
    <div className="py-4 flex justify-center w-full md:px-10">
      <div className={`flex w-[90vw] pr-3 ${isMobile ? "flex-col rounded-xl items-start" : "flex-row rounded-full items-center"} justify-between overflow-hidden`} 
        style={{ backgroundImage: gradient }}>

        {stepTitles.map((stepperStep) => (
          <div className='flex flex-row gap-3 items-center p-2' key={stepperStep.stepNumber}>
            <div className={`flex items-center justify-center w-[24px] h-[24px] rounded-full ${parseInt(stepperStep?.stepNumber) < uiStep ? "bg-midgrey" : parseInt(stepperStep?.stepNumber) === uiStep ? "bg-primary" : "bg-fadedgrey"} text-white font-bold`}>
              <p>{stepperStep?.stepNumber}</p>
            </div>
            <p className='text-sm font-[600]'>{stepperStep?.title}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
